import { isFeatureEnabled } from "./utils";

export const useFeatureFlags = () => {
  return { isFeatureEnabled };
};
